import axiosInstance from './axiosInstance';
import { REALM_NAME } from '../constants';

export const login = params => {
  return axiosInstance.post(`realms/${REALM_NAME}/protocol/openid-connect/token`, params, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const refreshToken = ({ refreshToken }) => {
  return axiosInstance.post(
    `realms/${REALM_NAME}/protocol/openid-connect/token`,
    new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: 'merchant-frontend',
      refresh_token: refreshToken,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

export const userInfo = ({ accessToken }) => {
  return axiosInstance.get(`/realms/${REALM_NAME}/protocol/openid-connect/userinfo`, {
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/jwt',
    },
  });
};

export const tokenIntrospect = ({ token }) => {
  return axiosInstance.post(
    `realms/${REALM_NAME}/protocol/openid-connect/token`,
    new URLSearchParams({
      grant_type: 'client_credentials',
      client_id: 'merchant-frontend',
      token,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

// tokenIntrospect({
//   token:
//     'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJvUjFLR01INmdILW9FRVhNZVU5Q3dIa1ZNWGRlWUxsQy1qWEhWSHlvbjlzIn0.eyJleHAiOjE3NDQxMjQyMjAsImlhdCI6MTc0NDEyMDYyMCwianRpIjoiYTI1ZDkwZjUtNjlkZi00Y2E1LTgzOTctNmZjMDFkN2VmYmExIiwiaXNzIjoiaHR0cHM6Ly9pZC5rOHMtZGV2LmFsaWYudXovcmVhbG1zL21lcmNoYW50cyIsImF1ZCI6WyJtZXJjaGFudCIsImFjY291bnQiXSwic3ViIjoiOTNlZGMxNTQtZGU1Mi00ZWRjLWEyYmYtNmIwOWFlNDRiNzA5IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoibWVyY2hhbnQtZnJvbnRlbmQiLCJzZXNzaW9uX3N0YXRlIjoiN2ExZjUyZmItNGMzMC00YmI0LTg4NTctMjY4ODMyNGU4NTk0IiwiYWNyIjoiMSIsImFsbG93ZWQtb3JpZ2lucyI6WyIqIl0sInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJvZmZsaW5lX2FjY2VzcyIsImRlZmF1bHQtcm9sZXMtbWVyY2hhbnRzIiwidW1hX2F1dGhvcml6YXRpb24iXX0sInJlc291cmNlX2FjY2VzcyI6eyJtZXJjaGFudCI6eyJyb2xlcyI6WyJtZXJjaGFudF9zY29yaW5nX2NhcmQiLCJsb2dpbiIsIm1lcmNoYW50X2JtbCIsIm1lcmNoYW50X21hbmFnZXIiLCJtZXJjaGFudF9tb2RlcmF0aW9uX2FsaWZzaG9wIiwibWVyY2hhbnRfYWNxdWlyaW5nIiwibWVyY2hhbnRfZGVsaXZlcmllcyIsIm1lcmNoYW50X21vZGVyYXRpb25fZ29vZHMiLCJtZXJjaGFudF9hcHBsaWNhdGlvbnMiLCJtZXJjaGFudF9hbGlmbmFzaXlhIiwibWVyY2hhbnRfdXBsb2FkX2dvb2RzIiwibWVyY2hhbnRfYWxpZnNob3AiLCJtZXJjaGFudF9hZG1pbiJdfSwiYWNjb3VudCI6eyJyb2xlcyI6WyJtYW5hZ2UtYWNjb3VudCIsIm1hbmFnZS1hY2NvdW50LWxpbmtzIiwidmlldy1wcm9maWxlIl19fSwic2NvcGUiOiJlbWFpbCBwcm9maWxlIHBob25lIiwic2lkIjoiN2ExZjUyZmItNGMzMC00YmI0LTg4NTctMjY4ODMyNGU4NTk0IiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImF1dGhfaWQiOjIxLCJuYW1lIjoiU2h1a3VyLCBORSIsIm1lcmNoYW50Ijp7Im5hbWUiOiJJZGVhIFN0b3LRgyIsImlkIjozfSwicmVhbG0iOiJtZXJjaGFudHMiLCJzdG9yZSI6eyJuYW1lIjoiSWRlYSAtS2FkeXNoZXZhIiwiaWQiOjQyMX0sInByZWZlcnJlZF91c2VybmFtZSI6Ijk5ODkwOTc1NjIyMyIsImdpdmVuX25hbWUiOiJTaHVrdXIsIiwiZmFtaWx5X25hbWUiOiJORSJ9.d85ub2aJL3Z8vn2zRAQFngzu2fmnije8WuOme0NRVeu-oNbiyTxDG7gYhHsncXQ0qS0AhMgDK4uTylJlhuW1ifPDnTLjsQjWtw_j6PZYDdukN7H8fXjtkqzQOb8CrMrV0O-yzvNZt9Ui_oJLQ3XI3MQC6DOLu81UAW90ObEZz8AwUswGHUUpQ5CM32CVeHfumeHq0HiY82tV8W8P1OuKvo8e8xRomE-oFqO48T-8Ue3r5hYP3dZ0O3W8vVbws4qK2s7oHkpeNDFVFrLrB23X_RsiSR9IgSLM5S1t3ZjAHnPgsTQg-lsgjrnmEvlo1mUlGgZ-Y4WDBqlneAR3hSzVwA',
// });

export const keycloakRefreshToken = refreshToken => {
  return axiosInstance.post(
    `realms/${REALM_NAME}/protocol/openid-connect/token`,
    new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: 'merchant-frontend',
      refresh_token: refreshToken,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

export const logout = ({ refreshToken }) => {
  return axiosInstance.post(
    `realms/${REALM_NAME}/protocol/openid-connect/logout`,
    new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: 'merchant-frontend',
      refresh_token: refreshToken,
    }),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
};
